import type { FileListResponse, FileResponse } from '@popety-io/types'
import { apiClient } from '@/services/apiClient'

export const filesService = {
  /**
   * Fetch files for a specific land
   */
  getByLandId: async (landId: string): Promise<FileListResponse> => {
    const response = await apiClient.get(`/files/land/${landId}`)
    return response.data
  },

  /**
   * Upload a new file for a land
   */
  uploadFile: async (
    id: string,
    file: File,
    type = 'land'
  ): Promise<FileResponse> => {
    const formDataObj = {
      file: file,
      entity_type: type,
      entity_id: id,
    }

    const response = await apiClient.post(`/files`, formDataObj, {
      formData: true,
    })

    return response.data
  },

  /**
   * Delete a file
   */
  deleteFile: async (fileId: string): Promise<void> => {
    await apiClient.delete(`/files/${fileId}`)
  },

  /**
   * Download a file
   */
  downloadFile: async (fileId: string): Promise<void> => {
    await apiClient.downloadFile(`/files/${fileId}/download`)
  },
}
